<mat-card>
    <mat-card-title>{{'report.title' | translate}}</mat-card-title>
    <mat-card-subtitle>{{'report.subtitle' | translate}}</mat-card-subtitle>
    <mat-card-content>
        <form class="report-form">
            <mat-form-field class="report-full-width">
                <mat-label>{{'report.form-title' | translate}}</mat-label>
                <input maxlength="100" required name="title" [(ngModel)]="bug.title" matInput placeholder="{{'report.form-title-hint' | translate}}">
            </mat-form-field>

            <mat-form-field class="report-full-width">
                <mat-label>{{'report.form-description' | translate}}</mat-label>
                <textarea rows="7" maxlength="1000" required name="description" [(ngModel)]="bug.description" matInput placeholder="{{'report.form-description-hint' | translate}}"></textarea>
            </mat-form-field>

            <button type="submit" mat-raised-button (click)="sendBug()">{{'report.send' | translate}}</button>
        </form>
    </mat-card-content>
</mat-card>